angular.module('cvsApp').controller('confirmIdentityController', ['$scope','$rootScope','title','$location','PAGE_PATH','validateDeepLinkModel',
	'authenticateGuestUserService','validations','msgManagerService','getSpecialtyWCMContentService','cvsAppData','errorModel',
	'webTrendsService','userSession','RequestServiceHelper','commonService','$state', 'itemCartModel', '$filter'
	,function($scope, $rootScope, title,$location, PAGE_PATH, VM,AGUS,validations,MMS,WCM,CAD,EM,WTS,UserSession,RequestServiceHelper,commonService,$state,ITC,$filter) {
	'use strict';
	var CIC=this;
	this.content=wcmContent;
		/**
		 * SP 12/08/2016 - ITPR015400 - Guest Refill
		 * Added logic to read WCM content from common file and using v2.0 WCM content service
		 */
		CIC.qRWcmContent = qRWcmContent;
	CIC.isMobile = cvsUtility.isMobile(); // check the device type.
		/**
		 * SP 03/22/2017
		 * Added new variable to track if guest refill is disabled/ enabled
		 * @type {boolean}
		 */
	CIC.isGRDisabled = CAD.getGRDisabled();


	$scope.title = title;
	var makePaymentOnly=false, guestRefill = false, trackOrder = false;
	CIC.showQRContainer=true;
	var currentDate=new Date();
	// CIC.dateOfBirth= (currentDate.getMonth()+1)+'/'+("0" + (currentDate.getDate())).slice(-2)+'/'+'1970'; // to set the default date;
		/**
		 * Guest Refill - 01/17/2017
		 * Changed as per UAT comment
		 * @type {string}
		 */
        /**
         SMP 125 - Specialty Android Registration Enhancements - Nov 2017 release
         SP 10182017 - Removed mobile specific behavior for date of birth field
         */
		CIC.dateOfBirth='01/01/1970';
	// 	if(CIC.isMobile){
	// 		CIC.dateOfBirth=new Date(1970, 0, 1);
	// }
	   
	var originalContextinformation;
		var contextInformation;
		if(_.isObject(VM.apiResponse.contextInformation)){
			contextInformation=VM.apiResponse.contextInformation.__text;
		}else{
			contextInformation=VM.apiResponse.contextInformation?VM.apiResponse.contextInformation:cvsUtility.queryMap.contextInformation;
		}
		/**
		 * Sudhir 02/10/2017 - Feb 2017 Regression defect fix
		 * Added logic to handle new line characters introduced by xmls2json library in IE11
		 * */
	contextInformation= contextInformation ? contextInformation.replace(/\n/g,'').toUpperCase():undefined;
	var memberOnlineStatus= VM.apiResponse.memberOnlineStatus ? VM.apiResponse.memberOnlineStatus.toUpperCase() : undefined;
	CIC.validations=validations.validationMessages("CI");
	var originalContextInformation=contextInformation;
	if(contextInformation && contextInformation=="OLP-BD" || contextInformation=="OLP-PS" || contextInformation=="OLP" ||
		contextInformation=="PS" || contextInformation=="BD" ){
		contextInformation="OP";
	}


	CAD.setSelect('QR');
        /**
		 * IM6494119 - Registration Tagging to include Secure Messaging - Feb 2018 release - SP 12202017
		 * Added tagging for XID flow
         */
	if(cvsUtility.queryMap.partialLoginToken && cvsUtility.queryMap.xid){
		CAD.setXIDMode();
		CIC.xidMode=true;
        var utagObj = { page_name:'quick reg: confirm id',
            scenario_name:"quick reg: sm",
        };
        if(self == top){
            utagObj.pagename = "QR-ConfirmID";
        }
        WTS.webTrendsUtag("OBJ",utagObj);
	}
		/**
		 * SP 12/08/2016 - ITPR015400 - Guest Refill
		 * Added logic to read WCM content from common file and using v2.0 WCM content service
		 */
	//WCM.getContent('IdentityUnauth',onContentSuccess);
		CIC.content.identity_unauth = CIC.qRWcmContent.identity_unauth;
	//WCM.getContent('QRUnauth',onContentSuccessQR);
		CIC.content.qr_unauth.reg_reminder_body=CIC.qRWcmContent.qr_unauth.reg_reminder_body;
	$scope.contextInfo = contextInformation;
	if(contextInformation=="OP"){
		CIC.onlinepayment=true;
		var utagObj = { page_name:'SRX: QuickReg: Pay: ConfirmID',
			scenario_step:"SRX: OnlinePay: Confirm",
			scenario_name:"SRX: QuickReg: OLP",
			scenario_step_number:"1",
			tsrc:cvsUtility.queryMap.source
		};
		/**
		 * sankar 11/22/2016 - ITPR017031 - quick register confirmidentity
		 * Added WTS pagename tag
		 */
		if(self == top){
			utagObj.pagename = "QR-ConfirmID";
		}
		WTS.webTrendsUtag("OBJ",utagObj);
		if(self == top){
			utagObj.pagename = "QR-ConfirmID";
		}
		utagObj= { page_name:'confirm ID',
			page_category:'authentication',
			scenario_step:"confirm ID",
			scenario_name:"unreg: OLP",
			tsrc:cvsUtility.queryMap.source
		};
		WTS.webTrendsUtag("OBJ",utagObj);

	} else if(contextInformation=="QR"){
        /**
		 * IM6383426 - Added screen source (Eg. NPE) in tagging for QR
		 * SP 11062017 Nov 2017 release
         * @type {boolean}
         */
		CIC.quickRegistration=true;
		var utagObj = { page_name:'Quick Reg: Confirm ID',
			page_category:'Specialty Registration',
			scenario_name:"Quick Reg: CC",
			scenario_step_number:'1',
			Page_Event:0,
			tsrc:cvsUtility.queryMap.source,
            qr_patientopt_source: VM.apiResponse.screenSource
		};
		if(self == top){
			utagObj.pagename = "QR-ConfirmID";
		}
		WTS.webTrendsUtag("OBJ",utagObj);

	} else if(contextInformation=="TAP"){
		CIC.trackAPackage=true;
		var utagObj = { page_name:'Quick Reg: Confirm ID',
			page_category:'Specialty Registration',
			scenario_name:"Quick Reg: TAP",
			scenario_step_number:'1',
			Page_Event:0,
			tsrc:cvsUtility.queryMap.source

		};
		if(self == top){
			utagObj.pagename = "QR-ConfirmID";
		}
		WTS.webTrendsUtag("OBJ",utagObj);

	} else if(contextInformation=="RFR"){
		CIC.readyForRefill=true;
		/**
	    * sankar 11/28/2016 - ITPR015400 - guest refill
	    * Added WTS page_name,page_category tag  and removed other tags
	    */
		/**
		 * SP 02/23/2017 - IM5564959
		 * Uncommented scenario related tagging
		 * @type {{page_name: string, page_category: string, scenario_name: string, scenario_step_number: string, Page_Event: number, tsrc: *}}
		 */
		var utagObj = {
			page_name:'Quick Reg: Confirm ID',
			page_category:'Specialty Registration',
			scenario_name:"Quick Reg: RFR",
			 scenario_step_number:'1',
			 Page_Event:0,
			 tsrc:cvsUtility.queryMap.source

		};
		if(self == top){
			utagObj.pagename = "QR-ConfirmID";
		}
		WTS.webTrendsUtag("OBJ",utagObj);

		//} else {
		// WTS.webTrendsUtag("OBJ",{ page_name:'QR: Confirm ID'});
	}

	if(contextInformation=="QR"){
		CIC.quickRegistration=true;
	}
	else if(contextInformation=="RFR"){
		CIC.readyForRefill=true;

	}
	else if(contextInformation=="OP"){
		CIC.onlinepayment=true;
	}

	CIC.continueConfirmIdentity=function(context){
		sessionStorage.clear();
		ITC.setCartItems();
		CIC.showInvalidDataError=false;
		/**
		 * SP 11/07/2016 - ITPR015400 - Guest Refill
		 * Setting guest refill flag
		 */
		CAD.setGuestRefill(true);
		CAD.setReviewOrder(true);
        // CIC.dateOfBirthValidator();
		if(CIC.confirmIndentityForm.$valid && !CIC.dateInvalid && !CIC.futureDateError && !CIC.thirteenYearsValidation && !CIC.dateFormatInvalid){
			angular.element("#mydiv").show();
			angular.element("#loader").show();
			var req = {
				tokenId: VM.header ? VM.header.tokenID : undefined,
				zipCode: CIC.zipCode,
				dob: $filter('date')(CIC.dateOfBirth, 'yyyy-MM-dd')
			};
			if(contextInformation=="TAP"){
				/*WTS.webTrendsUtag("OBJ",{ page_name:'QR: Landing - ER/Confirm ID w/ Skip: Continue to Register Button',
					page_category:'Quick Registration',
					event_name: "Track Package",
					tsrc:cvsUtility.queryMap.source,
					Page_Event:21
				});*/

			}else if(contextInformation=="QR"){
				WTS.webTrendsUtag("LINK",{ page_name:'QR: Confirm ID: Continue Button',
					page_category:'Quick Registration',
					tsrc:cvsUtility.queryMap.source,
					Page_Event:21
				});

			}else if(contextInformation=="RFR"){
				/**
			    * sankar 11/28/2016 - ITPR015400 - guest refill
			    * Added WTS page_name,page_category,event_name and event_category tag 
			    */
				WTS.webTrendsUtag("LINK",{ 
					page_name:'refill rx: guest refill',
					page_category:'payments and registration',
					event_name:'refill without account',
					event_category:'guest refill'
				});				
			}
			//cvsUtility.invokeSpinner();
			if(context && context=="OLP"){
				makePaymentOnly=true;
				}
				else if(context && context=="RFR"){
				guestRefill=true;
			}
            else if(context && context=="TAP"){
                trackOrder = true;
            }
            /**
             SMP 125 - Specialty Android Registration Enhancements - Nov 2017 release
             SP 10182017 - Removed mobile specific behavior for date of birth field
             */
			// if(CIC.isMobile){
			// req.dob = ("0" + (CIC.dateOfBirth.getMonth()+1)).slice(-2)+'/'+("0" + (CIC.dateOfBirth.getDate())).slice(-2)+'/'+CIC.dateOfBirth.getFullYear();
			// }

			AGUS.authenticateGuestUser(req,onAuthUserSuccess);

		}else{
			CIC.confirmIndentityForm.dob.$dirty=true;
			CIC.confirmIndentityForm.zip.$dirty=true;
		}
	};
	CIC.switchTabs=function(tab){
		CIC.triggertrackAPackageTab=true;
		switch(tab) {
			case 'QR':
				if(CIC.quickRegistrationTAP){
					CIC.quickRegistrationForm=true;
					CIC.showQRContainer=false;
				}else{
					CIC.showQRContainer=true;
					CIC.quickRegistrationForm=false;
				}
				CIC.showTrackAPackageContainer=false;
				break;
			case 'RFRLock':
				CIC.showQRContainer=false;
				CIC.quickRegistrationForm=false;
				CIC.lockRFRContainer = true;
				break;
		}
		if(tab=="QR"){
			if(CIC.quickRegistrationTAP){
				CIC.quickRegistrationForm=true;
				CIC.showQRContainer=false;
			}else{
				CIC.showQRContainer=true;
				CIC.quickRegistrationForm=false;
			}
			CIC.showTrackAPackageContainer=false;
		}else if(tab=="TAP"){
			CIC.showTrackAPackageContainer=true;
			CIC.showQRContainer=false;
			CIC.quickRegistrationForm=false;
		}
	};
	CIC.skipTrackAPackege=function(){
		/*CIC.showTrackAPackageContainer=true;
		 CIC.triggertrackAPackageTab=true;
		 CIC.showQRContainer=false;
		 CIC.quickRegistrationForm=false;
		 PAGE_PATH.SKIP_REG_TRACK_PACKAGE=true;*/
        CIC.continueConfirmIdentity(contextInformation);
		WTS.webTrendsUtag("LINK",{ page_name:'QR: Landing - ER/Confirm ID w/ Skip: Skip and Track Button',
			page_category:'Quick Registration',
			event_name: "Track Package",
			tsrc:cvsUtility.queryMap.source,
			Page_Event:21
		});

	};

	CIC.dateMasking = function(e) {
		cvsUtility.dateMaskingDDMMYYY(CIC,e);
	};
	CIC.allowOnlyNumbers=function(e){
		cvsUtility.allowOnlyNumbers(e);
	};

	// move path constant in constant file
	function onAuthUserSuccess(data){
		/**
          * sankar 02/10/2016 - SMP 009 - authenticateGuestUser service error
          * Modified page_error tag
          */
		if( data.SERVER_ERROR || (data.apiResponse && data.apiResponse.showError)){
     		var pageError = cvsUtility.getPageError(data, 'Fatal', 'authenticateGuestUser');
     		var utagObj={
                page_error:pageError
            };
     		WTS.webTrendsUtag("LINK",utagObj,undefined);
       	}
		//cvsUtility.stopSpinner();
		if(data.SERVER_ERROR){
			EM.Error(contextInformation);
			$location.path(PAGE_PATH.INVALID_REG);
			return;
		}
		if(data.getError()===""){
            VM.header.tokenID = data.header.tokenID;
			VM.header.apikey = cvsUtility.queryMap.apikey;
            if(!CAD.getGRDisabled()) {
                CAD.setGuestRefill(true);
            }
			CAD.setTokenId(data.header.tokenID);
			UserSession.init(false,"guest",data.header.tokenID);
			$rootScope.startSession();
			var specialtyConfigKeys = ['PAYMENT-PUB-KEY', 'fast_config'];
			var specialtyConfigMap = {};
			RequestServiceHelper.specialtyConfig(specialtyConfigKeys).then(function(response){
				/**
				 * RXMGMT - 21035: UI:
				 * COVID - 19 Banner on Select Delivery Address Page
				 */
				
				// var config=response.configurationResponse.config;
				// if(config && config.configKey && config.configKey=="PAYMENT-PUB-KEY"){
				// 	commonService.setPublicKey(config.configValue);
				// }
				
				if (!Array.isArray(response.configurationResponse.config)) {
					var config = response.configurationResponse.config;
					if (config && config.configKey && config.configKey == "PAYMENT-PUB-KEY") {
						commonService.setPublicKey(config.configValue);
					}
				}
				else {
					var config = [];
					config = response.configurationResponse.config;
					if (Array.isArray(config)) {
						$.each(config, function (index, configObj) {
							specialtyConfigMap[configObj.configKey] = configObj;
							if (configObj.configKey === 'PAYMENT-PUB-KEY') {
								commonService.setPublicKey(configObj.configValue);
							}
						});
						
					}
				}
				if (CAD.hasOwnProperty('setFeatureFlags') && specialtyConfigMap.hasOwnProperty('fast_config')) {
					var fastConfigValue = specialtyConfigMap['fast_config'].configValue.hasOwnProperty('__cdata') ? specialtyConfigMap['fast_config'].configValue.__cdata : specialtyConfigMap['fast_config'].configValue;
					var featureFlagsUnformatted = cvsUtility.xmlToJSON(fastConfigValue.replace(/[\n\r\t]+/g, ""));
					var featureFlags = {};
					var featureFlagsExtract = {};
					if (Array.isArray(featureFlagsUnformatted.fast_config.feature_config.config)) {
						$.each(featureFlagsUnformatted.fast_config.feature_config.config, function (index, obj) {
							if (obj.featureName === 'Disallow_PickUp_Warning_Banner') {
								featureFlagsExtract = obj;
							}
						});
					}
					switch (cvsUtility.getPlatform()) {
						case 'dweb':
							featureFlags[featureFlagsExtract.featureName] = featureFlagsExtract.channelswitches.desktop === 'y';
							break;
						case 'mweb':
							featureFlags[featureFlagsExtract.featureName] = featureFlagsExtract.channelswitches.mobileweb === 'y';
							break;
						case 'mapp':
							featureFlags[featureFlagsExtract.featureName] = featureFlagsExtract.channelswitches.mobileapp === 'y';
							break;
					}
					CAD.setFeatureFlags(featureFlags);
				}
			});
			switch(contextInformation){
				case "QR":
				case "QR-R":
				case "QRR":
				case "XID":
					PAGE_PATH.QR_TAG=true;
					if(!CAD.getGRDisabled()) {
                    CAD.setRFRTabData({isTabLocked: false});
					}

				case "RFR":
					PAGE_PATH.RFR_TAG=true;
					CIC.triggerQuickRegForm=true;
					CIC.quickRegistrationForm=true;
					CIC.showQRContainer=false;		
					CIC.lockRFRContainer = true;
					CAD.setQRTabData({isTabLocked: true});
					if(!CAD.getGRDisabled()) {
					CAD.setRFRTabData({isTabLocked: false});
					}
					CAD.setOPTabData({isTabLocked: false});
					CAD.setROTabData({isTabLocked: false});
					break;


				case "RO":
					PAGE_PATH.RFR_TAG=true;
					CIC.triggerQuickRegForm=true;
					CIC.quickRegistrationForm=true;
					CIC.showQRContainer=false;		
					//CIC.lockRFRContainer = true;
					CAD.setROTabData({isTabLocked: false});
					if(!CAD.getGRDisabled()) {
					CAD.setRFRTabData({isTabLocked: false});
					}
					CAD.setOPTabData({isTabLocked: false});
					break;


				case "OP":
					PAGE_PATH.OLP_TAG=true;
					CIC.triggerQuickRegForm=true;
					CIC.quickRegistrationForm=true;
					CIC.showQRContainer=false;
					CIC.quickRegistrationTAP=true;
					CAD.setOPTabData({isTabLocked: false});
					if(!CAD.getGRDisabled()) {
                    CAD.setRFRTabData({isTabLocked: false});
					}
					CAD.setROTabData({isTabLocked: false});
					break;
				case "TAP":
					PAGE_PATH.CONTINUE_REG_TRACK_PACKAGE=true;
					CIC.triggerQuickRegForm=true;
					CIC.quickRegistrationForm=true;
					CIC.showQRContainer=false;
					CIC.quickRegistrationTAP=true;
					CAD.setOPTabData({isTabLocked: false});
					if(!CAD.getGRDisabled()) {
                    CAD.setRFRTabData({isTabLocked: false});
					}
					CAD.setROTabData({isTabLocked: false});
					break;

				/* case "RFR":
				 $location.path(PAGE_PATH.READY_FOR_REFILL)
				 break;*/
				default:
					$location.path(PAGE_PATH.INVALID_REG);
					break;
			}
			if(makePaymentOnly){
				    WTS.webTrendsUtag("LINK",{ page_name:'link: confirm ID: make payment only',
					page_category:'payments',
					tsrc:cvsUtility.queryMap.source
				});
				CAD.setSelect('OP');
				$location.path('/account-balance');

			}
			else if(guestRefill){
				CAD.setSelect('RFR');
				CAD.setOPTabData({isSelected: false});
				CAD.setRFRTabData({isSelected: true});
				CAD.setQRTabData({isSelected: false});
				CAD.setTAPTabData({isSelected: false});
				$state.go("dashboard-refill-prescriptions", {}, { reload: true });
			}
            else if(trackOrder && CIC.quickRegistrationTAP) {
                CAD.setSelect('TAP');
                CAD.setOPTabData({isSelected: false});
                CAD.setRFRTabData({isSelected: true});
                CAD.setQRTabData({isSelected: false});
                CAD.setTAPTabData({isSelected: true});
                $state.go("dashboard-track-order", {id: CAD.getShipmentNumber()}, { reload: true });
            }
			else if(CIC.triggerQuickRegForm && CIC.quickRegistrationForm){
				//CAD.setSelect('RFR');
				$state.go("RR", {}, { reload: true });
			}else if(CIC.lockRFRContainer){
				CAD.setOPTabData({isSelected: false});
                CAD.setRFRTabData({isSelected: true});
                CAD.setQRTabData({isSelected: false});
                CAD.setTAPTabData({isSelected: false});
                $state.go("dashboard-refill-prescriptions", {}, { reload: true });
			}

		}else{
			if(data.getError().statusCode == MMS.errorCodes().EXCEEDED_ATTEMPTS.code){
				WTS.webTrendsUtag("OBJ",{ page_name:'QR: confirm ID - 3 Failed Attempts/ER Blocked',
					page_category:'Quick Registration',
					tsrc:cvsUtility.queryMap.source,
					page_error:cvsUtility.getPageError(data, 'Fatal', 'authenticateGuestUser'),
					Page_Event:0
				});

				WTS.webTrendsUtag("LINK",{ page_name:'QR: confirm ID: Continue Button',
					page_category:'Quick Registration',
					page_error:cvsUtility.getPageError(data, 'Fatal', 'authenticateGuestUser'),
					tsrc:cvsUtility.queryMap.source,
					Page_Event:21
				});

				$location.path(PAGE_PATH.INVALID_REG);
			}else if(data.getError().statusCode == MMS.errorCodes().INVALID_DOB.code){
				CIC.showInvalidDataError=true;
				WTS.webTrendsUtag("OBJ",{ page_name:'QR: Confirm ID - Error: Continue Button',
					page_category:'Quick Registration',
					tsrc:cvsUtility.queryMap.source,
					page_error:cvsUtility.getPageError(data, 'Fatal', 'authenticateGuestUser'),
					Page_Event:21
				});

				WTS.webTrendsUtag("LINK",{ page_name:'QR: confirm ID: Continue Button',
					page_category:'Quick Registration',
					page_error:cvsUtility.getPageError(data, 'Fatal', 'authenticateGuestUser'),
					tsrc:cvsUtility.queryMap.source,
					Page_Event:21
				});
			}else{
				var pageError = cvsUtility.getPageError(data, 'Fatal', 'authenticateGuestUser');
				var utagObj={
					page_error:pageError
				};
				WTS.webTrendsUtag("LINK",utagObj,undefined);
				EM.Error(contextInformation);
				$location.path(PAGE_PATH.INVALID_REG);
			}
		}
	}
	
	CIC.dateOfBirthValidator=function(){
		CIC.confirmIndentityForm.dob.$dirty=true;
		CIC.dateInvalid=false;
		CIC.dateFormatInvalid=false;
		CIC.thirteenYearsValidation=false;
		CIC.futureDateError=false;
		var dobStr = registrationformNew.dob.value;
		var dateArray = [];
		if(CIC.dateOfBirth){
			// var dob = $filter('date')(CIC.dateOfBirth, 'yyyy-MM-dd');
			// if(CIC.isMobile){
				// var newDate = ("0" + CIC.dateOfBirth.getDate()).slice(-2)+'/'+("0" + (CIC.dateOfBirth.getMonth()+1)).slice(-2)+'/'+CIC.dateOfBirth.getFullYear();
				//var newDate = ("0" + (CIC.dateOfBirth.getMonth()+1)).slice(-2)+'/'+("0" + (CIC.dateOfBirth.getDate())).slice(-2)+'/'+CIC.dateOfBirth.getFullYear();
				dateArray.push(("0" + CIC.dateOfBirth.split('/')[0]).slice(-2));
				dateArray.push(("0" + CIC.dateOfBirth.split('/')[1]).slice(-2));
				dateArray.push(CIC.dateOfBirth.split('/')[2]);

		   // }
			if(dateArray.length==3 && dateArray[0] && dateArray[1] && dateArray[2] && dateArray[0].length==2 && dateArray[1].length==2){
                /**
				 * SMP 0104/ 0117 - Oct Release - SP 08/24/2017
				 * Enabling all the members, irrespective of age, to use QR flow
                 */
				cvsUtility.validateDOB(CIC,dateArray[0],dateArray[1],dateArray[2], "parent");
			}else{
				if(dateArray.length==3 && (dateArray[0].length<2 || dateArray[1].length<2)){
					CIC.dateFormatInvalid=true;
					CIC.thirteenYearsValidation=false;
				}else{

					CIC.dateInvalid=true;
				}

			}
		}
		else if(dobStr === 'MM/DD/YYYY'){
            CIC.dateInvalid=true;
            CIC.dateFormatInvalid=false;
            setTimeout(function(){
                registrationformNew.dob.value = dobStr;
            },10);
		}
		else{
            CIC.dateInvalid=false;
            CIC.dateFormatInvalid=true;
            setTimeout(function(){
                registrationformNew.dob.value = dobStr;
			},10);

		}
	};

	$scope.makePaymentOnly =function(){
		CIC.switchTabs("OP");
	};

	$scope.$watch(function(){return CIC.dateOfBirth;},function(newval,oldval){
		CIC.dateInvalid=false;
		CIC.dateFormatInvalid=false;
		CIC.thirteenYearsValidation=false;
		CIC.futureDateError=false;
	});
	function onContentSuccess(data) {
		if(data.getError() === '') {
			CIC.content.identity_unauth = data.apiResponse.identity_unauth;
			//WCM.getContent('QRUnauth',onContentSuccessQR);
		}
	}
	function onContentSuccessQR(data){
		if(data.getError() === '') {
			if(CIC.content){
				CIC.content.qr_unauth.reg_reminder_body=data.apiResponse.qr_unauth.reg_reminder_body;
			}
		}
	}
	CIC.skipRegistration=function(){
		window.top.location=createChannelUrl(cvsUtility.queryMap.campaignName);
	}
		

}]);
